export default __webpack_public_path__ + "static/media/fuel-160535.dfd938a2.png";